<div class="modal show" id="votesModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel"></h5>
        <button type="button" class="close" data-dismiss="modal" (click)="close()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row" style="margin-top: 15px;">
          <div class="col-2" style="color: #046792;">Yes</div>
          <div class="col-1" style="color: #046792;">{{voteYCount}}</div>
          <div class="col-9">{{getVotes(yesVotes).join(', ')}}</div>
        </div>
        <div class="row" style="margin-top: 15px;">
          <div class="col-2" style="color: #046792;">No</div>
          <div class="col-1" style="color: #046792;">{{voteNCount}}</div>
          <div class="col-9">{{getVotes(noVotes).join(', ')}}</div>
        </div>
        <div class="row" style="margin-top: 15px;">
          <div class="col-2" style="color: #046792;">Abstain</div>
          <div class="col-1" style="color: #046792;">{{voteAbstainCount}}</div>
          <div class="col-9">{{getVotes(abstainVotes).join(', ')}}</div>
        </div>
        <div class="row" style="margin-top: 15px;">
          <div class="col-2" style="color: #046792;">Absent</div>
          <div class="col-1" style="color: #046792;">{{votesAbsentCount}}</div>
          <div class="col-9">{{getVotes(absentVotes).join(', ')}}</div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" (click)="close()">
          &times; Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show" id="backdrop" style="display: none;"></div>
